import React, { useCallback, useMemo } from 'react';
import {
    getLocalDevices, JazzSdk,
    USER_MEDIA_TYPE,
} from '@salutejs/jazz-sdk-web';
import bem from 'utils/bem.js';
import { Button } from 'components/Button/index.js';
import Text from 'components/Text/index.js';
import { useRoomContext } from '../../contexts/RoomContext';
import { useAudioOutputDevices } from './useAudioOutputDevices';
import { useAudioInputDevices } from './useAudioInputDevices';
import { useVideoInputDevices } from './useVideoInputDevices';
import { DevicesSelectField } from './DevicesSelectField';
import { handleError } from '../../utils/handleError';
import './index.sass';
import { useMobile } from 'utils/media.js';

const { block, el } = bem('media-settings')

export const MediaSettings = () => {
    const { sdk } = useRoomContext();
    const { isMobile } = useMobile();

    const localDevices = useMemo(() => {
        if (!sdk) return undefined;
        return getLocalDevices(sdk as JazzSdk);
    }, [sdk]);

    const { audioInputDevices, audioInputDeviceId, handleChangeAudioInput } = useAudioInputDevices(localDevices);
    const { audioOutputDevices, audioOutputDeviceId, handleChangeAudioOutput } = useAudioOutputDevices(localDevices);
    const { videoInputDevices, videoInputDeviceId, handleChangeVideoInput } = useVideoInputDevices(localDevices);

    const handleRequestPermissions = useCallback(() => {
        localDevices
            ?.requestUserMediaPermissions(
                USER_MEDIA_TYPE.AUDIO,
                USER_MEDIA_TYPE.VIDEO,
            )
            .catch((err) => {
                handleError(err, 'Ошибка при запросе доступа к медиа-устройствам');
            });
    }, [localDevices]);

    if (!audioInputDevices.length && !audioOutputDevices.length && !videoInputDevices.length) {
        return (
            <Button onClick={handleRequestPermissions}>
                <Text>Запросить разрешение</Text>
            </Button>
        );
    }

    return (
        <div className={ block() }>
            { !isMobile && <div className={ el('video-input') }>
                <Text tag='div' className={ el('label') }>Камера:</Text>
                <DevicesSelectField value={ videoInputDeviceId } onChange={ handleChangeVideoInput }
                                    options={ videoInputDevices } />
            </div> }
            <div className={ el('audio-input') }>
                <Text tag='div' className={ el('label') }>Микрофон:</Text>
                <DevicesSelectField value={ audioInputDeviceId } onChange={ handleChangeAudioInput }
                                    options={ audioInputDevices } />
            </div>
            <div className={ el('audio-output') }>
                <Text tag='div' className={ el('label') }>Вывод звука:</Text>
                <DevicesSelectField value={ audioOutputDeviceId } onChange={ handleChangeAudioOutput }
                                    options={ audioOutputDevices } />
            </div>
        </div>
    );
};
